import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Loader from 'components/loader'
import Dialoguemodal from 'components/dialoguemodal'
import ConfirmationModal from 'components/confimation-modal'
import { bannersApi } from '../restaurant.api'
import { BannersProvider, useBanners } from './banners.context'
import BannerForm from './banner-form'

function BannerCard({ banner, onEdit, onDelete }) {
  return (
    <div className='tw-rounded-[8px] tw-border tw-border-[#E7DFD9] tw-overflow-hidden tw-bg-white'>
      <div className='tw-relative tw-h-36 tw-bg-[#F2ECE7]'>
        {banner.image && (
          <img
            src={banner.image}
            alt={banner.title}
            className='tw-h-full tw-w-full tw-object-cover'
          />
        )}
        {banner.status !== 'active' && (
          <span className='tw-absolute tw-right-2 tw-top-2 tw-rounded tw-bg-[#C0392B] tw-px-2 tw-py-0.5 tw-text-xs tw-text-white'>
            Inactive
          </span>
        )}
        {banner.badge && (
          <span className='tw-absolute tw-left-2 tw-top-2 tw-rounded tw-bg-electricGreen tw-px-2 tw-py-0.5 tw-text-xs tw-text-white'>
            {banner.badge}
          </span>
        )}
      </div>
      <div className='tw-p-4'>
        <h3 className='tw-font-semibold tw-text-[15px]'>{banner.title}</h3>
        <p className='tw-text-sm tw-text-gray-500 tw-line-clamp-2'>
          {banner.subtitle}
        </p>
        <div className='tw-mt-3 tw-flex tw-gap-2'>
          <button
            type='button'
            onClick={() => onEdit(banner)}
            className='tw-text-[12px] tw-px-[10px] tw-py-[4px] tw-rounded-[5px] tw-border tw-border-gray-300 tw-text-gray-600'
          >
            Edit
          </button>
          <button
            type='button'
            onClick={() => onDelete(banner)}
            className='tw-text-[12px] tw-px-[10px] tw-py-[4px] tw-rounded-[5px] tw-border tw-border-[#FBE9E7] tw-text-[#C0392B]'
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  )
}

function BannersInner() {
  const { loading, banners, refresh } = useBanners()
  const navigate = useNavigate()
  const [formOpen, setFormOpen] = useState(false)
  const [editing, setEditing] = useState(null)
  const [deleting, setDeleting] = useState(null)

  const openCreate = () => {
    setEditing(null)
    setFormOpen(true)
  }

  const openEdit = (banner) => {
    setEditing(banner)
    setFormOpen(true)
  }

  const confirmDelete = async () => {
    const { response } = await bannersApi.remove(deleting._id)
    if (response?.success) await refresh()
    setDeleting(null)
  }

  return (
    <div>
      <div className='tw-flex tw-items-center tw-justify-between tw-gap-3 tw-mb-4'>
        <div>
          <button
            onClick={() => navigate('/order-management')}
            className='tw-text-[12px] tw-text-gray-400'
          >
            ← Order management
          </button>
          <h2 className='font-heading tw-text-2xl'>Banners</h2>
        </div>
        <button
          onClick={openCreate}
          className='tw-rounded-[6px] tw-bg-electricGreen tw-text-white tw-text-regular tw-py-[8px] tw-px-[20px] tw-whitespace-nowrap'
        >
          + Add banner
        </button>
      </div>

      {loading ? (
        <Loader />
      ) : banners.length ? (
        <div className='tw-grid tw-gap-4 md:tw-grid-cols-2'>
          {banners.map((banner) => (
            <BannerCard
              key={banner._id}
              banner={banner}
              onEdit={openEdit}
              onDelete={setDeleting}
            />
          ))}
        </div>
      ) : (
        <div className='tw-text-center tw-text-gray-400 tw-py-16'>
          No banners yet
        </div>
      )}

      <Dialoguemodal
        open={formOpen}
        onClose={() => setFormOpen(false)}
        title={editing ? 'Edit banner' : 'Create banner'}
      >
        {formOpen && (
          <BannerForm banner={editing} onClose={() => setFormOpen(false)} />
        )}
      </Dialoguemodal>

      <ConfirmationModal
        open={!!deleting}
        onClose={() => setDeleting(null)}
        onConfirm={confirmDelete}
      >
        <div className='tw-mb-4'>
          <h3 className='tw-text-lg tw-font-semibold tw-mb-1'>Delete banner</h3>
          <p className='tw-text-sm tw-text-gray-500'>
            Are you sure you want to delete “{deleting?.title}”? This cannot be
            undone.
          </p>
        </div>
      </ConfirmationModal>
    </div>
  )
}

function Banners() {
  return (
    <BannersProvider>
      <BannersInner />
    </BannersProvider>
  )
}

export default Banners
